import { render, staticRenderFns } from "./FloatingWhatsAppPopup.vue?vue&type=template&id=4db5c0a2"
import script from "./FloatingWhatsAppPopup.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsAppPopup.vue?vue&type=script&lang=js"
import style0 from "./FloatingWhatsAppPopup.vue?vue&type=style&index=0&id=4db5c0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports